export const versionStringToNumbers = (version: string): number[] => {
  const splitedNumber = version.split(".");
  if (splitedNumber.length === 2) {
    return [Number(splitedNumber[0]), Number(splitedNumber[1])];
  }
  return [0, 0];
};
